export default function ResetDialog({ onCancel, onConfirm }) {
  return (
    <div className="reset-wrap" data-testid="reset-dialog" role="alertdialog" aria-modal="true">
      <div className="reset-box">
        <p className="reset-label">STAFF CONTROL</p>
        <p className="reset-text" data-testid="reset-dialog-text">Are you sure? This will end the current session.</p>
        <div className="reset-actions">
          <button type="button" className="reset-btn reset-cancel" data-testid="reset-cancel-button" onClick={onCancel}>
            CANCEL
          </button>
          <button type="button" className="reset-btn reset-confirm" data-testid="reset-confirm-button" onClick={onConfirm}>
            RESET
          </button>
        </div>
      </div>
    </div>
  );
}
